import { ShareBox } from '@eb/eds-share-box';
import React from 'react';
import {
    label,
    shareType,
    trackShareAction,
} from '../../tracking/trackShareAction';
import { ShareEventModalProps } from '../ShareEventModal/ShareEventModal';

export const TrackedShareEvent = (shareEventProps: ShareEventModalProps) => {
    return (
        <ShareBox
            onClick={(id: shareType) => trackShareAction(label(id))}
            {...shareEventProps}
        />
    );
};
